import { render, staticRenderFns } from "./textStartNew.vue?vue&type=template&id=07568770&"
import script from "./textStartNew.vue?vue&type=script&lang=ts&"
export * from "./textStartNew.vue?vue&type=script&lang=ts&"
import style0 from "./textStartNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports